import React from 'react';

import { components } from 'react-select';
import { CheckRadio } from 'screens/home/tasksList/styles';
import styled from 'styled-components';
import { StyledBox } from 'styles/common';

import { UncheckedCircle } from 'constants/icons';
import theme from 'constants/theme';

import { Typography7 } from 'uiToolkit/Typography';

export const AdminRolesOptions = (props) => {
  const { label } = props.data;
  const { isSelected } = props;
  return (
    <components.Option {...props}>
      <SelectOption label={label} checked={isSelected} />
    </components.Option>
  );
};

export const AdminRolesMultiValueContainer = ({ selectProps, data }) => {
  const values = selectProps.value;
  if (values) {
    return values[values.length - 1].label === data.label ? data.label : `${data.label}, `;
  }
  return '';
};
const ChildWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 450px;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

export const SelectOption = ({
  label,
  avatar,
  designation,
  checked,
  radioColor = 'primary',
  hoverColor = 'textSecondary',
}) => (
  <StyledBox width={1}>
    <ChildWrapper>
      <Typography7
        style={{ marginLeft: '1rem' }}
        customColor={checked ? theme.palette.text.primaryBlue : theme.palette.text.heading}
      >
        {label}
      </Typography7>

      <CheckRadio
        disableRipple
        checked={checked}
        style={{ marginLeft: 'auto' }}
        checkedIcon={<UncheckedCircle size="smallest" color={radioColor} />}
        icon={<UncheckedCircle size="smallest" color="textSecondary" />}
        hoverColor={radioColor}
      />
    </ChildWrapper>
  </StyledBox>
);
